import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";

type Props = {
  style?: StyleProp<ViewStyle>;
};

export default function Multientrega({ style }: Props) {
  return (
    <Svg width={20} height={20} viewBox="0 0 500 500" style={style}>
      <Path
        fill="#fefefe"
        d="M237.5 23.5c88.784-1.035 157.284 35.299 205.5 109 35.396 62.669 41.396 128.002 18 196-28.042 69.043-77.542 114.876-148.5 137.5-91.363 22.427-169.196-.407-233.5-68.5-49.52-60.414-65.52-128.747-48-205C56.012 108.155 110.845 53.988 195.5 30c13.995-3.162 27.995-5.328 42-6.5zm-10 22c.167 56.334 0 112.668-.5 169a8216.216 8216.216 0 00-76.5-76c-9 8.333-17.667 17-26 26a22348.428 22348.428 0 00125.5 126 22027.46 22027.46 0 00124.5-125c-8.333-9-17-17.667-26-26a8216.216 8216.216 0 00-76.5 76c-.5-56.666-.667-113.332-.5-170 87.782 13.958 145.949 62.958 174.5 147 19.858 81.066.025 150.566-59.5 208.5-61.735 51.812-131.068 65.146-208 40C101.487 408.84 57.32 351.34 46 268.5 41.725 182.872 75.559 117.372 147.5 72c24.941-14.147 51.607-22.98 80-26.5z"
        opacity={0.956}
      />
      <Path
        fill="#e03d2a"
        d="M271.5 45.5c-.167 56.668 0 113.334.5 170a8216.216 8216.216 0 0176.5-76c9 8.333 17.667 17 26 26a22027.46 22027.46 0 01-124.5 125 22348.428 22348.428 0 01-125.5-126c8.333-9 17-17.667 26-26a8216.216 8216.216 0 0176.5 76c.5-56.332.667-112.666.5-169a253.887 253.887 0 0144 0z"
        opacity={0.975}
      />
      <Path
        fill="#df3d29"
        d="M124.5 218.5a2.428 2.428 0 012 .5 810.355 810.355 0 0132.5 33.5c.667 44 .667 88 0 132l-34-34a8707.86 8707.86 0 01-.5-132zM372.5 218.5c1.333 21.656 2 43.656 2 66l-.5 66-34 34c-.667-44-.667-88 0-132a1567.517 1567.517 0 0132.5-34z"
        opacity={0.982}
      />
      <Path
        fill="#df3d29"
        d="M227.5 326.5a306.999 306.999 0 0122 20l21-20c1 23.324 1.333 46.657 1 70h-44v-70z"
        opacity={0.961}
      />
    </Svg>
  );
}
